(function() { window.GUID_9bcd7ff4_fdc8_457d_a302_3b108055d828 = { getGuid: function() { return "9bcd7ff4-fdc8-457d-a302-3b108055d828"; } }; })();
var CS;
(function (CS) {
    class SignalRHelper {
        static get Instance() {
            if (!SignalRHelper.instance) {
                SignalRHelper.instance = new SignalRHelper();
            }
            return SignalRHelper.instance;
        }
        get ConnectionId() {
            var _a;
            return (_a = this.connection) === null || _a === void 0 ? void 0 : _a.connectionId;
        }
        constructor() {
            this.startCallbacks = [];
            this.Logging = false;
            if (!CS.GlobalConst.EnableSignalR)
                return;
            try {
                this.reconnectAttemptTimer = null;
                this.connection = new signalR.HubConnectionBuilder()
                    .withUrl("/signalr")
                    .withAutomaticReconnect()
                    .configureLogging(this.Logging ? signalR.LogLevel.Information : signalR.LogLevel.None)
                    .build();
                this.connection.onreconnecting(error => {
                    if (this.Logging) {
                        console.log('SignalR reconnecting', error);
                    }
                    //clearInterval(this.reconnectAttemptTimer);
                });
                this.connection.onreconnected(connectionId => {
                    if (this.Logging) {
                        console.log('SignalR reconnected', connectionId);
                    }
                    CS.Connection.Current.ConnectionSucceed();
                    //clearInterval(this.reconnectAttemptTimer);
                });
                this.connection.onclose(error => {
                    if (this.Logging) {
                        console.log('SignalR disconnected', error);
                    }
                    //clearInterval(this.reconnectAttemptTimer);
                    //this.reconnectAttemptTimer = window.setInterval(() => {
                    //    this.StartConnection();
                    //}, 5000); // Restart connection after 5 seconds.
                });
                this.inerror = false;
            }
            catch (e) {
                this.inerror = true;
                console.error("SignalRHelper constructor " + e);
            }
        }
        StartConnection(startCallback) {
            if (!CS.GlobalConst.EnableSignalR || this.inerror) {
                return;
            }
            if (this.Logging) {
                console.info('SignalR - StartConnection ' + this.connection.state);
            }
            if (this.connection.state === signalR.HubConnectionState.Disconnected) {
                this.connection.start()
                    .then(() => {
                    this.notifyCallers(startCallback);
                })
                    .catch(err => {
                    CS.Connection.Current.TestConnections();
                    console.error(err);
                });
            }
            else if (this.connection.state === signalR.HubConnectionState.Connected) {
                //clearInterval(this.reconnectAttemptTimer);
                this.notifyCallers(startCallback);
            }
            else if (this.connection.state === signalR.HubConnectionState.Connecting) {
                this.pollForConnection(() => {
                    this.notifyCallers(startCallback);
                });
            }
        }
        notifyCallers(startCallback) {
            // Connection succeeded logic
            CS.Connection.Current.ConnectionSucceed();
            if (startCallback) {
                startCallback.call(SignalRHelper.Instance);
            }
            else {
                if (this.Logging) {
                    console.info('SignalR - trigger all callbacks');
                }
                CS.DOM.$body.trigger("Start");
            }
        }
        pollForConnection(onConnected) {
            const timeout = 10000; // Timeout after 10 seconds
            const interval = 100; // Poll every 100ms
            let elapsed = 0;
            const poll = () => {
                if (this.connection.state === signalR.HubConnectionState.Connected) {
                    if (this.Logging) {
                        console.info('SignalR - Connection established during polling.');
                    }
                    onConnected();
                }
                else if (elapsed >= timeout) {
                    console.error('SignalR - Connection did not reach Connected state within timeout.');
                }
                else {
                    elapsed += interval;
                    setTimeout(poll, interval);
                }
            };
            poll();
        }
        Start(namespace, startCallback) {
            if (!CS.GlobalConst.EnableSignalR || this.inerror) {
                console.info("Start bypassed - inerror:" + this.inerror);
                return;
            }
            CS.DOM.$body.off("Start." + namespace);
            CS.DOM.$body.on("Start." + namespace, startCallback);
            this.StartConnection(startCallback);
        }
        Stop(namespace, hubDisconectMethod, methodParameter) {
            if (!CS.GlobalConst.EnableSignalR || this.inerror) {
                return;
            }
            //clearInterval(this.reconnectAttemptTimer);
            if (this.Logging) {
                console.info('SignalR - Stopping - ' + namespace);
                if (hubDisconectMethod) {
                    console.info('          and invoking ' + hubDisconectMethod);
                }
            }
            if (namespace) {
                CS.DOM.$body.off("Start." + namespace);
            }
            if (hubDisconectMethod) {
                this.Invoke(hubDisconectMethod, null, methodParameter);
            }
            else if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
                this.connection.stop();
            }
        }
        Invoke(methodName, callback, ...args) {
            if (!CS.GlobalConst.EnableSignalR || this.inerror) {
                return;
            }
            if (this.connection.state === signalR.HubConnectionState.Disconnected) {
                this.StartConnection(() => {
                    this.connection.invoke(methodName, ...args)
                        .then(result => {
                        callback === null || callback === void 0 ? void 0 : callback.call(this, result);
                    })
                        .catch(err => {
                        if (this.Logging) {
                            console.info(err);
                        }
                    });
                });
            }
            else {
                this.connection.invoke(methodName, ...args)
                    .then(result => {
                    callback === null || callback === void 0 ? void 0 : callback.call(this, result);
                })
                    .catch(err => {
                    if (this.Logging) {
                        console.error(methodName + " " + err);
                    }
                });
            }
        }
        Receive(name, callback) {
            if (!CS.GlobalConst.EnableSignalR || !this.connection || this.inerror) {
                return;
            }
            this.connection.off(name);
            this.connection.on(name, callback);
        }
    }
    CS.SignalRHelper = SignalRHelper;
})(CS || (CS = {}));

//# sourceMappingURL=cs-signalr.js.map
